import React from 'react';

import { withAuthorization } from '../Session';

const Admin = () => (
  <div>
    <h1>Admin</h1>
    <p>The Admin Page is accessible by every signed in user.</p>
  </div>
);

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Admin);